// Test IDs for the Profile feature. Naming follows the directive in
// ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const PROFILE = {
  page: 'profile-page',
  navLink: 'app-nav-profile',
  header: 'profile-header',
  banner: 'profile-banner',
  bannerEditButton: 'profile-banner-edit-button',
  bannerModal: 'profile-banner-modal',
  editButton: 'profile-edit-button',
  followButton: 'profile-follow-button',
  shareButton: 'profile-share-button',
  stats: 'profile-stats',
  tabs: 'profile-tabs',
  tab: (key) => `profile-tab-${key}`,
  currentlyReading: 'profile-currently-reading',
  favorites: 'profile-favorites',
  recentlyRead: 'profile-recently-read',
  tbrPreview: 'profile-tbr-preview',
  scribbles: 'profile-scribbles',
  scribbleCard: 'profile-scribble-card',
  writing: 'profile-writing',
  communities: 'profile-communities',
  emptyState: 'profile-empty-state',
  editModal: 'profile-edit-modal',
};
